// src/modules/config/components/panels/QRStatsPanel.tsx
import React from 'react';
import { Alert, Row, Col, Statistic, Progress } from 'antd';
import { QRCodeStats } from '@/types';

interface QRStatsPanelProps {
  qrStats: QRCodeStats | null;
}

export const QRStatsPanel: React.FC<QRStatsPanelProps> = ({ qrStats }) => {
  if (!qrStats) return null;

  return (
    <Alert
      message={
        <Row gutter={[16, 8]}>
          <Col xs={12} sm={6} md={6} lg={6}>
            <Statistic
              title="Всего активных блюд"
              value={qrStats.total_active_items}
              valueStyle={{ fontSize: '14px' }}
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6}>
            <Statistic
              title="С QR-кодами"
              value={qrStats.items_with_qr}
              valueStyle={{ fontSize: '14px', color: '#52c41a' }}
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6}>
            <Statistic
              title="Без QR-кодов"
              value={qrStats.items_without_qr}
              valueStyle={{ fontSize: '14px', color: '#faad14' }}
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6}>
            <div>
              <div style={{ fontSize: '12px', color: '#666' }}>Покрытие QR</div>
              <Progress
                percent={qrStats.qr_coverage_percent}
                size="small"
                status={qrStats.qr_coverage_percent === 100 ? 'success' : 'active'}
              />
            </div>
          </Col>
        </Row>
      }
      type="info"
      style={{ marginBottom: 16 }}
    />
  );
};